import {
  LOGOUT_FAILED,
  LOGOUT_REQUESTED,
  LOGOUT_SUCCESSFUL,
  REDIRECT_TO_ERRORPAGE,
  RESET_MSG
} from '../actions/logoutActions'

import NgrxAuth from '../../auth/Auth'

const Logout = (state = {}, action) => {
  switch (action.type) {
    case LOGOUT_REQUESTED:
      return Object.assign({}, state, {
        pageLoading: true
      })
    case LOGOUT_SUCCESSFUL:
      NgrxAuth.accessToken = null
      let msg = Object.assign({}, action.msg)
      let errMsg = {}
      if (msg.hasOwnProperty('message')) {
        msg.message.includes('timed out') || msg.message.includes('été interrompue.') ? errMsg = Object.assign({}, msg) : errMsg = Object.assign({}, msg)
      }
      return Object.assign({}, state, {
        pageLoading: false,
        errorMessage: null,
        user: null,
        state: undefined,
        msg: msg || errMsg
      })
    case REDIRECT_TO_ERRORPAGE:
      return Object.assign({}, state, {
        pageLoading: false
      })
    case LOGOUT_FAILED:
      return Object.assign({}, state, {
        pageLoading: false,
        errorMessage: action.errorMessage
      })
    case RESET_MSG:
      return Object.assign({}, state, {
        msg: null
      })
    default:
      return state
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/redux/reducers/logoutReducer.js